import type { UiStrings } from '../types'

const fr: UiStrings = {
  brand: 'Holecard EX',
  docTitleSuffix: 'Enregistrement du processus',
  tagline: 'Enregistrez siège · holes · board · ligne — carte de processus partageable',
  metaDescription:
    'Holecard EX — enregistrement de processus poker mobile. Enregistrez siège, hole cards, board et actions de street dans une carte partageable.',
  stepsAria: 'Étapes',
  prev: 'Retour',
  undo: 'Défaire',
  next: 'Suivant',
  nextSummary: 'Voir le résumé',
  privacyLink: 'Confidentialité et pubs',
  privacyTitle: 'Confidentialité et pubs',
  privacyHint: 'Brouillon pour la revue AdSense. À vérifier et mettre à jour avant la production.',
  privacyBack: 'Retour à l’app',
  privacyCollectTitle: '1. Informations collectées',
  privacyCollectBody:
    'Holecard EX assemble actuellement les brouillons de revue uniquement dans le navigateur. Aucun compte requis ; les données de main ne sont pas envoyées à un serveur. Les brouillons peuvent être conservés temporairement dans le sessionStorage de cet onglet (cette politique sera mise à jour si cela change).',
  privacyAdsTitle: '2. Cookies et publicités',
  privacyAdsBody:
    'Des réseaux pub tiers comme Google AdSense peuvent être utilisés. Les annonceurs peuvent utiliser des cookies ou identifiants d’appareil pour des pubs ciblées. Vous pouvez contrôler les pubs personnalisées dans le navigateur ou les paramètres Google Ads.',
  privacyContactTitle: '3. Contact',
  privacyContactBody: 'Pour les questions de politique, ouvrez une issue GitHub holdcard-ex.com. E-mail opérateur : TODO_OPERATOR_EMAIL dans la config du projet.',
  langAria: 'Langue',
  langCompactAria: 'Langue (compact)',
  koPathLink: '한국어',
  koPathLinkAria: 'Version coréenne (/ko)',
  enPathLink: 'English',
  enPathLinkAria: 'Version anglaise (/)',
  setupTitle: 'Table',
  setupHint: 'Joueurs · stack · blinds — puis Siège → Main → Ligne',
  players: 'Joueurs',
  playersUnit: (n) => `${n}-max`,
  sb: 'SB',
  bb: 'BB',
  ante: 'Ante (optionnel)',
  anteHint: 'Même unité que les blinds',
  effectiveStack: 'Stack effectif (BB, optionnel)',
  potBb: 'Pot (BB, optionnel)',
  metaOptionalHint: 'Laissez ante / stack eff / pot vides pour les masquer dans les résumés',
  setupDetailsToggle: 'Joueurs · ante · eff · pot · jetons',
  setupBasicsHint: 'Par défaut (6-max · 100bb) ok — Suivant ou avancer',
  setupMetaSetChip: 'Ante · eff · pot définis',
  stackUnit: 'Unité du stack',
  stackUnitBb: 'BB',
  stackUnitChips: 'Jetons',
  stackChips: 'Stack (jetons)',
  stackBb: 'Stack (BB)',
  stackChipsUnit: 'jetons',
  positionTitle: 'Siège',
  seatQuestion: 'Où étiez-vous assis ?',
  settingsBack: 'Retour',
  settingsSegAria: 'Réglages de table (joueurs · blindes · tapis)',
  lineSeatEditAria: 'Modifier le siège',
  lineHoleEditAria: 'Modifier les cartes',
  positionHint: (count, hint) => `${count}-max sièges${hint ? ` · ${hint}` : ''}`,
  tableVizAria: (n) => `Sièges table ${n}-max`,
  tableVizHeroBadge: 'vous',
  tableVizHeroSeatAria: (seat) => `${seat} (vous)`,
  tableVizDealer: 'D',
  tableVizDealerTitle: 'Bouton dealer',
  tableVizTapHint: 'Touchez votre siège sur la table',
  tableVizListFallback: 'Lister les sièges · codes',
  tableVizBlindsAria: (v) => `Blindes ${v}`,
  tableVizPotPlaceholder: 'Pot',
  tableVizPotValue: (v) => `Pot ${v}`,
  tableVizPotAria: (v) => `Pot ${v}`,
  tableVizStackAria: (v) => `Stack ${v}`,
  tableVizEmptyMark: '—',
  tableVizEffHint: (v) => `Eff ${v}bb`,
  tableVizEffTitle: 'Stack effectif (table entière, pas par siège)',
  tableVizStepDown: 'Diminuer',
  tableVizStepUp: 'Augmenter',
  tableVizEditDone: 'OK',
  tableVizInfoHint: 'Touchez blindes, pot ou stack sur la table pour modifier',
  seatAbbrevHint: 'Abréviations de siège. Touchez pour le nom complet.',

  cardsTitle: 'Main',
  cardsHint: 'Commencez par vos cartes · adversaires via « Ajouter adversaires » · slot · couleur et rang · pas de doublons',
  heroHolesGuide: (seat) => `Choisissez les 2 hole cards de ${seat}.`,
  cardSlot1: 'Carte 1',
  cardSlot2: 'Carte 2',
  cardSlotSelect: 'Choisir',
  seatsLabel: 'Sièges',
  knownHolesOptional: 'Les hole cards adverses sont optionnelles (showdown / revue — vide OK)',
  holesBySeat: 'Hole cards · choisir un siège',
  seatVillain: (pos) => `Vilain ${pos}`,
  seatFilled: 'OK',
  holesModeHeroOnly: 'Mes cartes seules',
  holesModeWithVillains: 'Ajouter adversaires',
  holesModeAria: 'Mode de saisie des hole cards',
  villainNudgeToast: 'Main adverse connue ? Touchez BB / CO etc.',
  heroCardsDoneCta: 'Aller à la ligne',
  heroCardsAddVillainsCta: 'Ajouter adversaires',
  suitPickerLabel: 'Couleur',
  rankPickerLabel: 'Rang',
  boardTitle: 'Board',
  boardHint: 'Quand on y arrive — sauter pour préflop seul',
  flop: 'Flop',
  turn: 'Turn',
  river: 'River',
  flopSlot: (i) => `F${i}`,
  actionsTitle: 'Ligne',
  actionsHint: 'Ligne d’actions street par street — fold / check / call / bet / raise / all-in',
  actorQuick: 'Acteur rapide',
  actor: 'Acteur',
  actorPlaceholder: 'Entrer un nom',
  actorCustomToggle: 'Nom personnalisé',
  actorRequired: 'Entrez ou sélectionnez un acteur',
  action: 'Action',
  sizeLabel: 'Taille',
  sizePlaceholder: 'ex. 2.5bb',
  sizeRequired: 'Entrez une taille pour bet/raise',
  sizeCustomToggle: 'Personnalisé',
  sizeOpenApprox: 'Open',
  sizePotApprox: 'Taille du pot',
  sizeOverbetApprox: 'Overbet',
  sizeJamApprox: 'Short / jam',
  sizeUnitBb: 'bb',
  sizeUnitPct: 'pot',
  snapHint: 'S’aligne sur les stops · ± un cran',
  favoritesLabel: 'Favoris',
  morePresets: 'Plus de préréglages',
  presetsSizeLabel: 'Préréglages · taille',
  potSizeHintUnset: 'Définissez le pot (BB) dans le setup pour voir la taille en bb',
  clearOptional: 'Effacer',
  betRaiseHint: 'Bet : pas d’agression préalable · Raise : face à un bet/raise',
  allinSizeHint: 'Taille all-in optionnelle',
  sizeActionHint: (potBit) => potBit ? `Bet=premier · Raise=vs bet · ${potBit}` : 'Bet=premier · Raise=vs bet',
  addAction: (street) => `Ajouter action ${street}`,
  updateAction: 'Mettre à jour',
  editAction: 'Modifier',
  cancelEdit: 'Annuler',
  noStreetActions: (street) => `Pas encore d’actions ${street}.`,
  delete: 'Supprimer',
  moveUp: 'Haut',
  moveDown: 'Bas',
  allActionsHint: (n) => `${n} actions au total · voir les autres onglets`,
  heroChip: (pos) => pos,
  seatOrderHu: 'HU : BTN joue SB · ordre BTN/SB → BB',
  seatOrder: (order) => `Ordre des sièges : ${order}`,
  positionHintHuBtn: 'Bouton HU (SB)',
  keepActorHint: 'Les onglets de street gardent l’acteur (seul type/taille se réinitialisent)',
  potQuickPrompt: 'Pot rapide (BB) — touchez pour définir et rafraîchir l’indice',
  potQuickClear: 'Effacer le pot',
  quickLinesLabel: 'Lignes rapides',
  quickLinesHint: 'Modèles courants — touchez pour ajouter',
  macroOpenThenCall: 'Open puis call',
  macroFoldToHero: (seat) => `Folds jusqu’à ${seat}`,
  macroCbet33: 'C-bet ⅓ pot',
  quickLinesSwitchStreet: 'Changez de street pour les macros',
  macroOpenExists: 'Un open (raise) est déjà enregistré',
  macroAlreadyLogged: 'Open et call sont déjà enregistrés',
  macroFoldToHeroNone: (seat) => `Plus de folds tôt (ou ${seat} agit en premier)`,
  macroFoldToHeroBlocked: 'Action précoce déjà notée — ajoutez les folds à la main',
  boardCtaFlop: 'Ajouter le flop',
  boardCtaTurn: 'Ajouter le turn',
  boardCtaRiver: 'Ajouter la river',
  quickHand: 'Main rapide',
  skipToCards: 'Aller aux cartes',
  jumpToActions: 'Aller à la ligne',
  skipBoardPreflop: 'Sauter le board — préflop seul',
  boardSlotsToggle: 'Ajouter le board',
  softStackAria: 'Main jusqu’ici',
  softStackLine: 'Ligne',
  softStackHoles: 'Holes',
  softStackBoard: 'Board',
  streetTabWithCount: (street, n) => `${street} · ${n}`,
  actionIndexLabel: (n, street) => `Action ${n} · ${street}`,
  copyLinkTitle: 'Rouvre cette main dans l’app',
  suitStickyHint: 'Couleur maintenue · touchez une couleur pour changer',
  suitStickyChip: (s) => `Couleur actuelle ${s}`,
  suitMruLabel: 'Récents',
  summaryHint: 'Capturez la carte de processus ci-dessous ou copiez/partagez le texte',
  summaryHole: 'Hole cards',
  summaryBoard: 'Board',
  summaryActions: 'Actions',
  timelineProcess: 'Processus',
  timelineBoard: (cards) => `Board ${cards}`,
  processMoreSummary: 'Plus de processus',
  linePeekSummary: 'Ligne jusqu’ici',
  takeawayLabel: 'Takeaway',
  takeawayPlaceholder: 'Siège + ligne seulement — ex. BTN raise, BB call, flop check',
  takeawayHint: 'Une ligne de processus — siège + ligne seulement',
  takeawayNudge: 'Note de processus (facultatif)\u00a0· siège\u00a0· ligne',
  takeawayInLinkFact: 'La note de processus est dans le lien',
  shareSecondarySummary: 'Note · adversaires (facultatif)',
  shareSecondaryInvite: 'Laisser une ligne de processus (facultatif)',
  shareMoreSummary: 'Autres partages',
  lineDraftSummary: 'Acteur · taille',
  explainModeLabel: 'Expliquer',
  explainModeAria: 'Mode explication — afficher les aides',
  reviewScopeLabel: 'Revoir jusqu’à',
  reviewScopePreflop: 'Preflop',
  reviewScopeFlop: 'Flop',
  reviewScopeRiver: 'River',
  reviewScopeAria: 'Portée de revue — plie les streets suivantes (ne supprime pas)',
  shareProcessHu: 'Heads-up',
  shareProcessMultiway: 'Multiway',
  shareReviewedLabel: 'Relu',
  summaryCopyLabel: 'Coller dans le chat — lisible + Pro',
  summaryProLabel: 'Notation Pro',
  emptyDash: '—',
  copyBoth: 'Partager dans le chat',
  copyHuman: 'Lisible',
  copyPro: 'Notation Pro',
  copied: 'Copié ✓',
  copiedToast: 'Résumé copié',
  screenshotHint: 'Capture = photo nette · Lien = rouvrir la main',
  captureMode: 'Capture',
  captureExit: 'Quitter la capture',
  saveShareImage: "Enregistrer l'image",
  shareImage: "Partager l'image",
  imageSaved: 'Enregistré ✓',
  imageShared: 'Partagé ✓',
  imageSavedToast: 'Image enregistrée',
  imageSharedToast: 'Image partagée',
  imageFailedToast: "Impossible de créer l'image",
  shareText: 'Partager le texte',
  shared: 'Partagé ✓',
  copyLink: 'Copier le lien',
  linkCopiedToast: 'Lien de main copié',
  linkWithoutKnownHolesToast: 'Lien copié sans hole cards villains (trop long)',
  linkTooLongToast: 'Main trop grande pour un lien',
  sharedToast: 'Partagé',
  shareFailedToast: 'Échec du partage',
  newHand: 'Nouvelle main',
  receivedQuietRerecordCta: 'Enregistrer mon propre processus',
  draftRestoredHint: 'Brouillon restauré — continuer ou recommencer ?',
  draftContinue: 'Continuer',
  actorFoldedHint: 'Déjà fold',
  summaryHeading: '[Résumé Holecard EX]',
  summaryPlayers: (n) => `Joueurs : ${n}-max`,
  summaryBlinds: (b) => `Blinds : ${b}`,
  summaryHero: (p) => `Siège : ${p}`,
  summaryStack: (s) => `Stack : ${s}`,
  summaryEff: (e) => `Stack eff : ${e} BB`,
  summaryPot: (p) => `Pot : ${p} BB`,
  summaryHoleLine: (h) => `Hole : ${h}`,
  summaryHolesHeader: 'Holes:',
  summaryKnownHoleLine: (label, cards) => `· ${label}: ${cards}`,
  summaryBoardLine: (b) => `Board : ${b}`,
  summaryActionsHeader: '── Actions ──',
  summaryFooter: '— Créé avec Holecard EX',
  summaryProHeader: '── Notation Pro ──',
  tableLine: (n, blinds) => `${n}-max · ${blinds}`,
  errorBlinds: 'Blinds invalides. BB doit être > 0 ; SB ≥ 0 et ≤ BB.',
  hintFlopPartial: 'Le flop a généralement 3 cartes',
  hintNoActions: 'Sans actions, c’est possible — « Terminer la saisie » partage ce qui est noté jusqu’ici',
  missingFlopBoard: 'Actions de flop présentes mais board flop manquant',
  missingTurnBoard: 'Actions de turn présentes mais carte turn manquante',
  missingRiverBoard: 'Actions de river présentes mais carte river manquante',
  boardActionsMismatch: 'Actions sur une street dont le board est vide',
  boardNeedFlop: 'Le flop est vide — ajoutez des cartes pour une revue plus claire',
  boardNeedFlopPartial: 'Terminez la saisie du flop',
  boardNeedTurn: 'La carte turn est vide — ajoutez-la pour une revue plus claire',
  boardNeedRiver: 'La carte river est vide — ajoutez-la pour une revue plus claire',

  softGateTitle: 'Certains champs sont encore vides',
  softGateBody: 'Les hole cards sont encore vides. Ajoutez les holes pour enregistrer le processus, ou continuez quand même.',
  softGateFix: "Ajouter hole cards",
  softGateForceConfirm: "Partager incomplet quand même ?",
  softGateMissingHoles: (seat) => `Hole cards ${seat} (2)`,
  softGateMissingActions: "Au moins une action",
  softGateBodyLead: "Encore besoin de :",
  incompleteBadge: "Incomplet",
  softGateContinue: 'Voir le résumé quand même',
  softGateShare: 'Partager quand même',
  softGateCopy: 'Copier quand même',
  softGateCancel: 'Retour',
  pickerDisabled: 'Aucun slot sélectionné',
  step: {
    setup: 'Table',
    position: 'Siège',
    cards: 'Main',
    board: 'Board',
    actions: 'Ligne',
    summary: 'Partager',
  },
  street: {
    preflop: 'Préflop',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
  },
  actionType: {
    fold: 'Fold',
    check: 'Check',
    call: 'Call',
    bet: 'Bet',
    raise: 'Raise',
    allin: 'All-in',
  },
  suit: {
    s: 'Pique',
    h: 'Cœur',
    d: 'Carreau',
    c: 'Trèfle',
  },
  positionHintMap: {
    UTG: 'Under the gun',
    "UTG+1": 'UTG+1',
    MP: 'Middle',
    "MP+1": 'MP+1',
    HJ: 'Hijack',
    CO: 'Cutoff',
    BTN: 'Bouton (dealer)',
    SB: 'Petite blind',
    BB: 'Grosse blind',
  },
  progressAria: (current, total, label) =>
    `Étape ${current} sur ${total} : ${label}`,
  adArea: 'Emplacement pub',
  adTop: 'Pub haut',
  adBottom: 'Pub bas',
  adPlaceholderHint: 'ID AdSense non défini — espace réservé jusqu’au déploiement',
  // Softwise M10b: memory-order input
  endHere: "Terminer ici",
  finishRecord: "Terminer la saisie",
  reviewAnte: (v) => `ante ${v}`,
  reviewEffStack: (v) => `eff. ${v}`,
  reviewBreakdownAria: 'Par street',
  reviewPlayers: (n) => `${n} joueurs`,
  // vocab-tags:start — screen-only poker vocabulary (review breakdown)
  reviewVocab: {
    trips: 'trips',
    paired: 'pairé',
    monotone: 'monotone',
    twoTone: 'bicolore',
    rainbow: 'rainbow',
    limp: 'limp',
    open: 'open',
    threeBet: '3-bet',
    fourBet: '4-bet',
    fiveBet: '5-bet',
    squeeze: 'squeeze',
    coldCall: 'cold call',
    checkRaise: 'check-raise',
    cBet: 'c-bet',
    donkBet: 'donk bet',
    probeBet: 'probe bet',
  },
  shareSavedMark: 'Enregistré',
  // vocab-tags:end
  flowAskFlop: "Flop · 3 cartes",
  flowAskTurn: "Turn · 1 carte",
  flowAskRiver: "River · 1 carte",
  flowWhoActs: "À parler",
  flowSizeCustom: "Autre",
  flowSizeConfirm: "OK",
  flowSizeLabel: "Taille (bb)",
  flowDone: "Ligne enregistrée",
  flowRewind: "Refaire à partir d’ici",
  flowRewindCancel: "Annuler",
  flowSeatUnrecorded: "non noté",
  flowSeatNotInvolved: "hors du coup",
  flowMemoryCut: "Je ne me souviens plus à partir d'ici",
  lineStripAria: "Ligne enregistrée jusqu’ici",
  // Soft G: optional ending record (L1.5) — seat-subject, press-only, Quiet
  endingSummary: 'Fin de main (facultatif)',
  endingShownLabel: 'Cartes montrées au showdown',
  endingPotLabel: 'Pot',
  endingCardsInput: 'Cartes',
  endingMuck: 'Non montrées (muck)',
  endingUnknown: 'Inconnu',
  endingPotTo: (seat) => `${seat} prend le pot`,
  endingSplit: 'Partagé',
  endingLineLabel: 'Fin de main',
  endingShownCards: (seat, cards) => `${seat} montre ${cards}`,
  endingShownMuck: (seat) => `${seat} non montrées (muck)`,
  endingShownUnknown: (seat) => `${seat} cartes inconnues`,
  endingPotSplit: 'Pot partagé',
  endingPotUnknown: 'Pot inconnu',
  linkWithoutEndingToast: 'Lien trop long : fin de main omise',
  linkWithoutTakeawayToast: 'Lien trop long : note de processus omise',
  endingShownAria: (seat) => `${seat} cartes au showdown`,
}

export default fr
